import type { MiseSellerSellerGroupMap } from '@/lib/types/mise/seller';

/**
 * 店舗グループマッピング（集計後）から、店舗が属する店舗グループの ID を引く。
 * 生成AIの比較分析が比較先に使うのと同じ対応なので、ユーザー作成時の比較店舗グループの初期値に使う。
 */
export function findMappedSellerGroupId(
  mappings: MiseSellerSellerGroupMap[],
  sellerId: string,
): string | undefined {
  if (!sellerId) return undefined;
  return mappings.find((m) => m.seller_id === sellerId)?.seller_group_id;
}
